<div class="error-page-container">
  <mat-card class="error-page-card">
    <div class="error-page-header">
      <mat-card-title class="error-page-title">
        Deleted Applicant
      </mat-card-title>
    </div>

    <mat-card-content>
      The applicant you are looking for has been deleted.
    </mat-card-content>
    <mat-card-actions>
      <a routerLink="/dashboard"
         mat-button
         color="primary">Go home</a>
    </mat-card-actions>
  </mat-card>
</div>